export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          关于我们<i className="ri-information-line text-primary-500 ml-2"></i>
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">了解91黑料</p>

        <div className="mt-8 max-w-4xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <div className="flex flex-col md:flex-row items-start gap-6 md:gap-10">
              <div className="flex-shrink-0 w-full md:w-72 aspect-video md:aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20editorial%20newsroom%20with%20multiple%20screens%20displaying%20social%20media%20feeds%20and%20breaking%20news%2C%20warm%20ambient%20lighting%2C%20dark%20wood%20desk%2C%20professional%20yet%20dynamic%20atmosphere%2C%20red%20accent%20details%2C%20clean%20composition%2C%20cinematic%20mood&width=600&height=450&seq=about-91hl&orientation=landscape"
                  alt="91黑料编辑团队"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-heading font-bold text-foreground-900">
                  91黑料网 — 吃瓜视频与爆料资讯聚合平台
                </h3>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                  91黑料网成立于2020年，是国内领先的泛娱乐八卦资讯聚合平台。我们专注于追踪娱乐圈、网红圈以及各大社交平台的最新爆料、吃瓜视频与热点曝光内容。
                </p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  平台以"不打烊"为核心理念，全天候不间断更新，为吃瓜群众提供最新鲜、最全面的黑料内容。无论是明星塌房、网红翻车、直播事故还是社交平台争议话题，91黑料都在第一线为您带来真实爆料。
                </p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  目前平台涵盖娱乐八卦、社会热点、直播翻车、选秀内幕、品牌风波等多个内容板块，日更新量超过200条，已成为广大网民获取"吃瓜"内容的首选入口。
                </p>
                <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-shield-check-line text-primary-500"></i>信息严格审核</span>
                  <span className="flex items-center gap-1"><i className="ri-eye-off-line text-primary-500"></i>保护爆料人隐私</span>
                  <span className="flex items-center gap-1"><i className="ri-refresh-line text-primary-500"></i>7×24小时更新</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}